<template>
    <div v-if="outlet">
        <v-ons-list v-if="show_item == 'disabled'">
            <v-ons-list-header class="header-alert header-danger">This store is not taking orders</v-ons-list-header>
        </v-ons-list>

        <v-ons-list v-if="show_item == 'warning_message'">
            <v-ons-list-header class="header-alert header-warning">{{ outlet.opening_times_info.status }}</v-ons-list-header>
        </v-ons-list>

        <v-ons-list v-if="show_item == 'error_message'">
            <v-ons-list-header class="header-alert header-danger">{{ outlet.opening_times_info.status }}</v-ons-list-header>
        </v-ons-list>
    </div>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    export default {
        name: "open_warning",

        props: ['sticky'],

        computed: {

            ...mapGetters([
                'outlet',
            ]),

            show_item(){

                if (this.outlet == null)
                    return

                if (this.outlet.enabled == false)
                    return 'disabled'

                if (this.outlet.opening_times_info.is_open == false){

                    if (this.outlet.opening_times_info.can_preorder)
                        return 'warning_message'

                    return 'error_message'
                }

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/js/components/fragments/open_warning.vue